import { graphql } from '@/gql';

// Fragments
import './grocerySearchItemRowFragment';

graphql(`
  fragment GrocerySearchItemFragment on PaginatedGrocerySearchItemTypeResponse {
    count
    rows {
      ...GrocerySearchItemRowFragment
    }
  }
`);
